import { useState, useEffect, useRef } from "react"
import CustomTable from "../customs/CustomTable"
import CustomFilter from "../common/CustomFilter";
import { labels } from "../resources";
import { ServerKeys } from "../utils/serverKeys";
import { formatDisplayDate, formatIndianStyle, getFilteredValues, getGroupedOptions, getMonthsFromQuarters, getTimestamp, orderedData, parseValue } from "../helper/arrayFormatter";
import { Col, Divider, Row, Spin, Tooltip } from "antd";
import CustomSelect from "../customs/CustomSelect";
import { useFormik } from "formik";
import CustomButton from "../customs/CustomButton";
import CustomCard from "../customs/CustomCard";
import { axiosGet, axiosPost } from "../services/http.services";
import { API_AIRLINE_FILTER_URL, API_ALLAIRPORT, API_FILTER_URL, API_GET_DATA } from "../api/api";
import CustomDatePicker from "../customs/CustomDatePicker";
import MismatchGuideAccordion from "../components/common/MismatchGuideAccordion";
import dayjs from "dayjs";
import { HttpStatusCode } from "axios";
import MakeGraph from "../customs/MakeGraph";
import TabSlider from "../customs/TableSelector";
import Dydiff from "./Dydiff";
import DisplayFilterData from "../customs/DisplayFilterData";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";

const html2pdf = require('html2pdf.js');
const XLSX = require('xlsx');
const { saveAs } = require('file-saver');

const AllQuarters = ["Q1", "Q2", "Q3", "Q4"]
const AllMonths = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"]


const preferredOrder = ["Airport", "CITY", "Airline", "Status", "total_pax", "dy_pax", "pax_pesc",
	"pax_boarding", "entry_via_app", "entry_kiosk", "dy_perc",];
const subcategories = ["Airport", "AP-Quarter", "AP-Monthly", "AL-Quarter", "AL-Monthly"]


const formatUpdatedTimestamp = (value) => {
	if (!value) {
		return "Not available yet";
	}

	const parsedDate = new Date(value);
	if (Number.isNaN(parsedDate.getTime())) {
		return "Not available yet";
	}

	return parsedDate?.toDateString().replace(' ', ', ') + ' ' + parsedDate?.toLocaleTimeString();
}

const normalizeCityName = (value) => String(value || "").replace(/\s*\([A-Z]{3,4}\)\s*$/, "").trim();


const MainDashboard = () => {
	const { userData } = useSelector((state) => state.auth);
	const userAirports = userData?.airports ? JSON.parse(userData?.airports) : []
	const navigate = useNavigate();

	const initialFilterValues = {
		[ServerKeys.AIRPORT]: userAirports,
		[ServerKeys.AIRLINE]: [],
		[ServerKeys.STATUS]: [],
		[ServerKeys.YEAR]: [],
		[ServerKeys.MONTH]: [],
		[ServerKeys.Date]: [],
		[ServerKeys.START_DATE]: "",
		[ServerKeys.END_DATE]: "",
		[ServerKeys.CUR_GRAPH_TYPE]: "Airport"
	}

	const initialFilterOutValues = {
		[ServerKeys.AIRPORT]: [],
		[ServerKeys.AIRLINE]: [],
		[ServerKeys.STATUS]: [],
		[ServerKeys.YEAR]: [],
		[ServerKeys.MONTH]: [],
	}

	const [TableData, setTableData] = useState([])
	const [loading, setLoading] = useState(false);
	const [airportOptions, setAirportOptions] = useState([]);
	const [airlineOptions, setAirlineOptions] = useState([]);
	const [MonthOptions, setMonthOptions] = useState([]);
	const [StatusOptions, setStatusOptions] = useState([]);
	const [dateFilterOptions, setDateFilterOptions] = useState([])
	const [airportCityMap, setAirportCityMap] = useState({})
	const [tableLoader, setTableLoader] = useState(false)
	const [LastUpdatedTime, setLastUpdatedTime] = useState("")
	const [CurGraphType, setCurGraphType] = useState("Airport")
	const [ShowFilterOut, setShowFilterOut] = useState(false)

	// Chart Data States
	const [FirstChartData, setFirstChartData] = useState({})
	const [SecondChartData, setSecondChartData] = useState({})
	const [ShowSecondGraph, setShowSecondGraph] = useState(false)
	const [isDownloadPdf, setIsDownloadPdf] = useState(false)
	const [Dummy, setDummy] = useState(0)
	const CurGraphCode = useRef(true)
	const isRowClicked = useRef(false)
	const DydiffRef = useRef(false)
	const isFirst = useRef(true)

	// Graph Titles
	const FirstGraphTitle = CurGraphCode.current ? (ShowSecondGraph ? `${FirstChartData?.[CurGraphType] || "TOTAL"} - Touchpoint` : `Airports - DY`)
		: `${FirstChartData?.[CurGraphType] || "TOTAL"} - Usage`

	const SecondGraphTitle = CurGraphCode.current ? `${SecondChartData?.[CurGraphType] || "TOTAL"} - Airlines`
		: `${SecondChartData?.[CurGraphType] || "TOTAL"} - Usage`


	useEffect(() => {
		fetchDataApi()
	}, [])

	useEffect(() => {
		if (airlineOptions?.length > 0) {
			DashboardFilterFormik?.handleSubmit()
		}
	}, [airlineOptions])

	useEffect(() => {
		if (ShowFilterOut || isFirst.current) {
			isFirst.current = false
			return
		}

		FilterOutFormik?.resetForm({
			values: initialFilterOutValues,
		});

		// Call defualt Filter Data
		DashboardFilterFormik?.handleSubmit()
	}, [ShowFilterOut])

	useEffect(() => {
		if (!ShowSecondGraph) {
			isRowClicked.current = false
		}

		if (isRowClicked.current) {
			return
		}

		formatGraphData(TableData);
	}, [TableData, ShowSecondGraph])

	const formatGraphData = (Data = TableData, value = undefined, justSet = undefined) => {
		isRowClicked.current = value ? true : false
		if (CurGraphCode.current) {
			if (!ShowSecondGraph && !justSet) {
				let tempData = {}
				Data?.forEach((item) => {
					if (item["Airport"] === "TOTAL") {
						return
					}
					tempData[item["Airport"]] = item["AIRLINE SUM"] ?? item["dy_pax"] ?? "0"
				})

				setFirstChartData(tempData)
				setSecondChartData({})
			}
			else {
				if (!value) {
					value = TableData?.[0]
				}

				let keys1 = []
				try {
					keys1 = Object.keys(value);
				} catch (error) {
					keys1 = []
				}

				let tempTData = { ...value }
				let tempTData1 = {}

				// First Graph Parse
				let Graph1Keys = keys1.slice(-8)
				Graph1Keys?.forEach((key) => {
					tempTData1[key] = tempTData[key]
				})
				tempTData1["Airport"] = tempTData["Airport"]
				delete tempTData1["Latestdate"]

				// Second Graph Parse
				keys1.slice(-8).forEach((key) => {
					delete tempTData[key];
				});
				delete tempTData["Latestdate"]

				// Set Data
				setFirstChartData(tempTData1)
				setSecondChartData(tempTData)

				setTimeout(() => {
					setShowSecondGraph(true)
				}, 100);
			}

			return
		}

		// Handle row click
		if (justSet) {
			justSet(value)
			return
		}

		// If is not consolidated Airport view
		if (Data?.length > 0) {
			setFirstChartData(Data?.[0])
			setSecondChartData(Data?.[1])
		} else {
			setFirstChartData({})
			setSecondChartData({})
		}
	}

	const handleFormikChange = async (formik, key, value) => {
		await formik?.setFieldValue(key, value)
		DashboardFilterFormik.handleSubmit()
	};

	const buildDashboardRequest = (fitervalues, overrideAirport = undefined) => {
		const values = { ...fitervalues }
		delete values[ServerKeys.Date]

		const startTrue = values[ServerKeys.START_DATE]
		const endTrue = values[ServerKeys.END_DATE]

		if (startTrue || endTrue) {
			let tempArr = {}
			if (startTrue) {
				tempArr["start"] = startTrue
			}

			if (endTrue) {
				tempArr["end"] = endTrue
			}

			values["Date"] = tempArr
		}
		delete values[ServerKeys.START_DATE];
		delete values[ServerKeys.END_DATE];

		if (values.MONTH_YEAR?.length > 0 && !(values.MONTH_YEAR?.every((item) => item?.startsWith("Q")) && values.MONTH_YEAR?.some((item) => item?.startsWith("Q")))) {
			values.MONTH_YEAR = getMonthsFromQuarters(values.MONTH_YEAR)
		}

		values.Airport = getFilteredValues(
			values?.Airport?.length ? values?.Airport : userAirports,
			FilterOutFormik?.values?.Airport,
			userAirports
		);
		values.Airport = overrideAirport ? [overrideAirport] : ((userAirports?.length && values?.Airport?.length === 0) ? userAirports : values.Airport)
		values.Airline = getFilteredValues(values?.Airline, FilterOutFormik?.values?.Airline, airlineOptions?.map((item) => item?.value));
		values.Status = getFilteredValues(values?.Status, FilterOutFormik?.values?.Status, StatusOptions?.map((item) => item?.value));
		values.Year = getFilteredValues(values?.Year, FilterOutFormik?.values?.Year, dateFilterOptions?.[1]?.options?.map((item) => item?.value));
		values.MONTH_YEAR = getFilteredValues(values?.MONTH_YEAR, FilterOutFormik?.values?.MONTH_YEAR, AllMonths, true);

		let tempAirline = airlineOptions?.map((item) => item?.value)
		if (values.Airline?.length === 0) {
			values.Airline = getFilteredValues(tempAirline, FilterOutFormik?.values?.Airline, tempAirline);
		}

		return values
	}

	const simpleSort = (temp) => {
		if (temp?.length === 0) {
			return temp
		}

		temp = temp?.sort((a, b) => parseValue(b?.["dy_pax"]) - parseValue(a?.["dy_pax"]));
		return temp
	}


	function sortMonthsInsideObject(obj) {
		// Extract the keys (excluding the 'Airport' key)
		const monthKeys = Object.keys(obj).filter(key => key !== 'Airport');
		if (monthKeys.some((item) => item?.includes("Q"))) {
			return obj;
		}

		// Sort the keys in chronological order
		const sortedMonthKeys = monthKeys.sort((a, b) => {
			const dateA = new Date(`${a} 1`);
			const dateB = new Date(`${b} 1`);
			return dateA - dateB;  // Sorts in ascending order
		});

		// Create a new object with sorted keys
		const sortedObj = {};
		sortedObj[CurGraphType] = obj.Airport;
		sortedMonthKeys.forEach(key => {
			sortedObj[key] = obj[key];
		});

		return sortedObj;
	}


	const DashboardFilterFormik = useFormik({
		enableReinitialize: true,
		initialValues: initialFilterValues,
		onSubmit: async (fitervalues) => {
			setTableLoader(true)
			const values = buildDashboardRequest(fitervalues)

			try {
				const curUrl = CurGraphType === "Airport" ? API_FILTER_URL : API_AIRLINE_FILTER_URL;
				const response = await axiosPost(curUrl, values)
				if (response?.status === HttpStatusCode.Ok) {
					// console.log("Filter Resp: ", response.data);
					let transformedData = response.data.map((item) => {
						let transformedItem = {};

						// Loop through each key in the current object
						for (let key in item) {
							try {
								transformedItem[key] = item[key].replace(/\.00\b/g, "");
							} catch (error) {
								transformedItem[key] = '0';
							}
						}

						if (["Airport", "Airline"].includes(fitervalues?.[ServerKeys.CUR_GRAPH_TYPE])) {
							let dateString = item["Latestdate"]
							const formattedDate = formatDisplayDate(dateString, "-")
							transformedItem["Latestdate"] = formattedDate
						}

						if (transformedItem["Airport"]) {
							const airportCode = String(transformedItem["Airport"] || "").trim().toUpperCase();
							transformedItem["CITY"] = airportCode === "TOTAL" ? "" : (airportCityMap[airportCode] || "");
						}

						return transformedItem;
					});


					if (CurGraphCode.current) {
						transformedData = simpleSort(transformedData)
					}
					else {
						transformedData = transformedData.map(sortMonthsInsideObject);
					}

					setTableData(transformedData)
					setTableLoader(false)
					isRowClicked.current = false
				}
			} catch (error) {
				console.log(error || "Something went wrong")
				setTableLoader(false)
			}
		}
	});

	const FilterOutFormik = useFormik({
		enableReinitialize: true,
		initialValues: initialFilterOutValues,
		onSubmit: () => {
			DashboardFilterFormik.handleSubmit()
		}
	});

	// Reset form to initial values when needed
	const resetFormToInitialValues = () => {
		CurGraphCode.current = true
		const tempInitValues = { ...initialFilterValues }
		tempInitValues[ServerKeys.CUR_GRAPH_TYPE] = "Airport"
		setCurGraphType("Airport");

		DashboardFilterFormik.resetForm({
			values: tempInitValues,
		});

		DashboardFilterFormik.handleSubmit()
		setDummy(val => val + 1)
		setShowFilterOut(false)
	};

	const dynamicColumn = (data) => {
		let KeysList = []
		if (data?.[0]) {
			KeysList = Object.keys(data?.[0]).filter((key) => !String(key).startsWith("_"))
		}
		const hasExplicitAirlineFilter = Boolean(DashboardFilterFormik.values?.[ServerKeys.AIRLINE]?.length)

		const columns = data?.[0] ? KeysList
			.sort((a, b) => {
				// Sort the keys based on the preferred order
				let aIndex = preferredOrder.indexOf(a);
				let bIndex = preferredOrder.indexOf(b);

				// Handle placing "Latestdate" at the end
				if (a === "Latestdate") return 1;
				if (b === "Latestdate") return -1;

				if (aIndex === -1) return 1;  // If 'a' is not in the preferredOrder, move it to the end
				if (bIndex === -1) return -1; // If 'b' is not in the preferredOrder, move it to the end

				return aIndex - bIndex; // Otherwise, sort by the predefined order
			})
			?.map((key, index) => {
				const handleClick = (event, record) => {
					// Prevent the default click behavior
					event.preventDefault();
					event.stopPropagation()

					const targetElement = document.getElementById("DydiffComp");

					if (targetElement) {
						targetElement.scrollIntoView({ behavior: 'smooth' });
					}

					const dydiffFilters = buildDashboardRequest(DashboardFilterFormik.values, record["Airport"])
					DydiffRef.current?.setContext({
						airports: [record["Airport"]],
						statuses: dydiffFilters?.Status || [],
						years: dydiffFilters?.Year || [],
						months: dydiffFilters?.MONTH_YEAR || [],
						start_date: dydiffFilters?.Date?.start || "",
						end_date: dydiffFilters?.Date?.end || "",
					})
				};

				return {
					title: <CustomFilter key={index}
						title={key?.replace(/_/g, ' ')?.toUpperCase()}
						titleClassName={airlineOptions?.map((item) => item?.value)?.includes(key) ? "text-green" : index === 0 ? "text-[#FFF]" : "text-[#3B82F6]"}
					/>,
					align: "center",
					dataIndex: key,
					key: index,
					fixed: index === 0 ? "left" : undefined,
					sorter: (a, b) => {
						if ([a[CurGraphType], b[CurGraphType]].includes("TOTAL")) {
							return 0
						}

						const aValue = a?.[key];
						const bValue = b?.[key];

						// If both are numbers (after parsing), compare them
						if (typeof aValue === "string" && typeof bValue === "string") {
							const aParsed = parseValue(aValue);
							const bParsed = parseValue(bValue);

							if (!isNaN(aParsed) && !isNaN(bParsed)) {
								return aParsed - bParsed; // Numeric comparison
							} else {
								// If one or both values can't be parsed, fallback to string comparison
								return aValue.localeCompare(bValue);
							}
						} else {
							// Handle other types, fallback to default
							return 0;
						}
					},
					render: (text, record) => {
						let isDiff = false;
						let fontRed = false;
						let isTotal = false;
						const hasMismatch = record?.["_has_mismatch"] === "1";

						if (!hasExplicitAirlineFilter && key === "dy_diff" && (text !== "0" || hasMismatch)) {
							isDiff = true;
						}

						if (!hasExplicitAirlineFilter && (record?.["dy_diff"] !== "0" || hasMismatch) && (key === "entry_via_app" || key === "entry_kiosk")) {
							fontRed = true;
						}

						if (!hasExplicitAirlineFilter && (key === "dy_pax" || key === "AIRLINE SUM") && record["dy_pax"] !== record["AIRLINE SUM"]) {
							fontRed = true;
						}

						if (record?.Airport === "TOTAL") {
							isTotal = true;
						}

						return (
							<div style={{ position: 'relative' }}
								onClick={(e) => (isDiff || fontRed) && !isTotal && handleClick(e, record)}
							>
								{/* Show Tooltip only on hover if isDiff or fontRed is true */}
								{(isDiff || fontRed) ? (
									<Tooltip title="Data Mismatch" styles={{ root: { fontSize: "12px" } }}>
										<p style={{
											position: 'relative',
											backgroundColor: (isDiff || fontRed) ? isTotal ? "orange" : "#D70040" : "",
											paddingBottom: isDownloadPdf && (isDiff || fontRed || index === 0) ? '8px' : '0px'
										}}
											className={`text-right ${(isDiff || fontRed) ? "text-white font-bold rounded-sm px-1" : index === 0 ? "font-semibold text-white bg-[#3B82F6] px-2 rounded-sm" : "font-normal"}`}
										>
											{formatIndianStyle(text) + (key?.endsWith("perc") ? "%" : "")}
										</p>
									</Tooltip>
								) : (
									<p style={{
										position: 'relative',
										backgroundColor: "",
										paddingBottom: isDownloadPdf && (isDiff || fontRed || index === 0) ? '8px' : '0px'
									}}
										className={`text-right ${(isDiff || fontRed) ? "text-white font-bold rounded-sm px-1" : index === 0 ? "font-semibold text-white bg-[#3B82F6] px-2 rounded-sm" : "font-normal"}`}
									>
										{formatIndianStyle(text) + (key?.endsWith("perc") ? "%" : "")}
									</p>
								)}
							</div>
						);
					},
				}
			})
			: []
		return columns
	}

	const fetchDataApi = async () => {
		try {
			setLoading(true)
			const [response, airportResponse] = await Promise.all([
				axiosGet(API_GET_DATA),
				axiosGet(API_ALLAIRPORT),
			]);

			if (airportResponse?.status === 200) {
				const cityMap = Object.fromEntries(
					(airportResponse?.data || [])
						.map((row) => {
							const code = String(row?.[0] || "").trim().toUpperCase();
							const city = normalizeCityName(row?.[1]);
							if (!code) {
								return null;
							}
							return [code, city];
						})
						.filter(Boolean)
				);
				setAirportCityMap(cityMap);
			}

			if (response?.status === 200) {
				// console.log("Data log", response?.data);
				setLoading(false)
				if (userData?.airports) {
					let tempAP = JSON.parse(userData?.airports)
					setAirportOptions(tempAP?.map(val => ({ 'label': val, 'value': val })))
				}
				else {
					setAirportOptions(response?.data?.Airport)
				}
				setAirlineOptions(response?.data?.airlines)
				setDateFilterOptions([
					getGroupedOptions(response?.data?.ytd?.map((ele) => ele?.label), labels.ytd, true),
					getGroupedOptions(response?.data?.Year?.map((ele) => ele?.label), labels.year, true),
				])

				setMonthOptions([
					getGroupedOptions(AllQuarters, labels.quarter, true),
					getGroupedOptions(AllMonths, labels.month, true),
				]);

				setStatusOptions(response?.data?.Status)

				setLastUpdatedTime(formatUpdatedTimestamp(response?.data?.LastUpdatedTime))
			}
		} catch (error) {
			setLoading(false)
			console.log(error);
		}
	}

	const subCatOnClick = (val) => {
		CurGraphCode.current = false
		if (val === "Airport") {
			setCurGraphType("Airport")
			val = "Airport"
			CurGraphCode.current = true
		}
		else if (val?.startsWith("AP-")) {
			setCurGraphType("Airport")
			val = val?.replace("AP-", "")
		}
		else if (val?.startsWith("AL-")) {
			setCurGraphType("Airline")
			val = val?.replace("AL-", "")
		}

		handleFormikChange(DashboardFilterFormik, ServerKeys.CUR_GRAPH_TYPE, val, true)
	}

	const exportToExcel = () => {
		const wb = XLSX.utils.book_new();
		const ws = XLSX.utils.json_to_sheet(orderedData(TableData, preferredOrder));
		XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');

		// Generate Excel file
		const excelFile = XLSX.write(wb, { bookType: 'xlsx', type: 'array' });

		const timestamp = getTimestamp();
		const filename = `DY-Table_${timestamp}.xlsx`;
		saveAs(new Blob([excelFile]), filename);
	};

	const downloadPageAsPdf = () => {
		setIsDownloadPdf(true)

		const element = document.getElementById("MainView");

		// Calculate content size
		const contentWidth = element.offsetWidth;
		const contentHeight = element.offsetHeight;

		const scaleFactor = 0.4; // Adjust scale to fit content within page
		const pdfWidth = contentWidth * scaleFactor;
		const pdfHeight = contentHeight * scaleFactor;

		const options = {
			image: { type: 'jpeg', quality: 1 },
			html2canvas: {
				scale: 3,
				letterRendering: true,
				logging: false
			},
			jsPDF: {
				unit: 'mm',
				format: [pdfWidth, pdfHeight],
				orientation: 'landscape'
			}
		};

		const timestamp = getTimestamp();
		const filename = `DY-Home-Report_${timestamp}.pdf`;

		// Generate the PDF
		html2pdf()
			.from(element)
			.set(options)
			.save(filename);

		setTimeout(() => {
			setIsDownloadPdf(false)
		}, 500);
	};

	return (
		<CustomCard>
			<Row gutter={[3, 20]} className={ShowFilterOut ? "mb-3" : "mb-4"} key={Dummy} style={{ alignItems: "flex-end" }}>
				<Col className="mr-3">
					<CustomSelect
						name={ServerKeys.AIRPORT}
						label={labels.Airport}
						options={airportOptions}
						value={DashboardFilterFormik.values?.[ServerKeys.AIRPORT]}
						onChange={(option) => handleFormikChange(DashboardFilterFormik, ServerKeys.AIRPORT, option)}
						mode="multiple"
					/>
				</Col>

				<Col className="mr-3">
					<CustomSelect
						name={ServerKeys.AIRLINE}
						label={labels.airline}
						value={DashboardFilterFormik.values?.[ServerKeys.AIRLINE]}
						options={airlineOptions}
						mode="multiple"
						onChange={(option) => handleFormikChange(DashboardFilterFormik, ServerKeys.AIRLINE, option)}
					/>
				</Col>

				<Col className="mr-3">
					<CustomSelect
						name={ServerKeys.STATUS}
						label={labels.status}
						options={StatusOptions}
						value={DashboardFilterFormik.values?.[ServerKeys.STATUS]}
						onChange={(option) => handleFormikChange(DashboardFilterFormik, ServerKeys.STATUS, option)}
						mode="multiple"
					/>
				</Col>

				<Col className="mr-3">
					<CustomSelect
						label={labels.year}
						value={DashboardFilterFormik.values[ServerKeys.YEAR]}
						options={dateFilterOptions}
						mode="multiple"
						onChange={(option) => handleFormikChange(DashboardFilterFormik, ServerKeys.YEAR, option)}
					/>
				</Col>


				<Col className="mr-3">
					<CustomSelect
						label={labels.month}
						value={DashboardFilterFormik.values[ServerKeys.MONTH]}
						options={MonthOptions}
						mode="multiple"
						onChange={(option) => handleFormikChange(DashboardFilterFormik, ServerKeys.MONTH, option)}
					/>
				</Col>

				<Col className="mr-3">
					<CustomDatePicker
						name={ServerKeys.START_DATE}
						label={labels.startDate}
						value={DashboardFilterFormik?.values?.startDate}
						placeholder="Select Date"
						onChange={(selectedDate) => handleFormikChange(
							DashboardFilterFormik,
							ServerKeys.START_DATE,
							selectedDate ? selectedDate.format("YYYY-MM-DD") : ""
						)}
						disableDate={(date) => {
							return dayjs(date).isAfter(dayjs(DashboardFilterFormik?.values?.endDate), "day");
						}}
					/>
				</Col>

				<Col className="mr-3">
					<CustomDatePicker
						name={ServerKeys.END_DATE}
						label={labels.endDate}
						placeholder="Select Date"
						value={DashboardFilterFormik?.values?.endDate}
						onChange={(selectedDate) => handleFormikChange(
							DashboardFilterFormik,
							ServerKeys.END_DATE,
							selectedDate ? selectedDate.format("YYYY-MM-DD") : ""
						)}
						disableDate={(date) => {
							return dayjs(date).isBefore(dayjs(DashboardFilterFormik?.values?.startDate), "day");
						}}
					/>
				</Col>


				<Col>
					<CustomButton
						label={labels.clearAll}
						onClick={resetFormToInitialValues}
						disabled={!airportOptions?.length}
					/>
				</Col>
			</Row>


			{ShowFilterOut && <Row gutter={[3, 20]} className="mb-4" key={Dummy + 5} style={{ alignItems: "flex-end" }}>
				<Col className="mr-3">
					<CustomSelect
						name={ServerKeys.AIRPORT}
						label={labels.Airport}
						options={airportOptions}
						value={FilterOutFormik.values?.[ServerKeys.AIRPORT]}
						onChange={(option) => handleFormikChange(FilterOutFormik, ServerKeys.AIRPORT, option)}
						mode="multiple"
						placeholder={`${labels.exclude}`}
						lableClassName="text-red font-semibold"
					/>
				</Col>

				<Col className="mr-3">
					<CustomSelect
						name={ServerKeys.AIRLINE}
						label={labels.airline}
						value={FilterOutFormik.values[ServerKeys.AIRLINE]}
						options={airlineOptions}
						placeholder={`${labels.exclude}`}
						lableClassName="text-red font-semibold"
						mode="multiple"
						onChange={(option) => handleFormikChange(FilterOutFormik, ServerKeys.AIRLINE, option)}
					/>
				</Col>

				<Col className="mr-3">
					<CustomSelect
						name={ServerKeys.STATUS}
						label={labels.status}
						options={StatusOptions}
						value={FilterOutFormik.values?.[ServerKeys.STATUS]}
						onChange={(option) => handleFormikChange(FilterOutFormik, ServerKeys.STATUS, option)}
						mode="multiple"
						placeholder={`${labels.exclude}`}
						lableClassName="text-red font-semibold"
					/>
				</Col>

				<Col className="mr-3">
					<CustomSelect
						label={labels.year}
						value={FilterOutFormik.values[ServerKeys.YEAR]}
						placeholder={`${labels.exclude}`}
						lableClassName="text-red font-semibold"
						options={[dateFilterOptions?.[1]]}
						mode="multiple"
						onChange={(option) => handleFormikChange(FilterOutFormik, ServerKeys.YEAR, option)}
						disabled={DashboardFilterFormik.values[ServerKeys.YEAR]?.includes("YTD") && !(FilterOutFormik.values[ServerKeys.YEAR]?.some((item) => DashboardFilterFormik.values[ServerKeys.YEAR]?.includes(item)))}
					/>
				</Col>

				<Col className="mr-3">
					<CustomSelect
						label={labels.month}
						value={FilterOutFormik.values[ServerKeys.MONTH]}
						placeholder={`${labels.exclude}`}
						lableClassName="text-red font-semibold"
						options={MonthOptions}
						mode="multiple"
						onChange={(option) => handleFormikChange(FilterOutFormik, ServerKeys.MONTH, option)}
					/>
				</Col>

				<Tooltip title="Note: Selecting same values in Filter and Exclusion cancels each other.">
					<span style={{ fontSize: 14, fontWeight: "bold", fontStyle: "italic", color: '#1890ff', borderRadius: 20, borderWidth: 2, padding: 5, paddingInline: 13, cursor: "default" }}>i</span>
				</Tooltip>
			</Row>}


			{/* Subcategories as clickable items */}
			<div style={{ display: "flex" }}>
				<TabSlider key={Dummy} defaultTab={0} subcategories={subcategories} subCatOnClick={(val) => subCatOnClick(val)} />

				<CustomButton className="ml-2" icon={<img src={require("../assests/download.png")} alt="download" loading="lazy"
					style={{ width: 15, height: 15 }} />}
					label={"PDF"}
					onClick={downloadPageAsPdf}
				/>

				<CustomButton className="ml-2" icon={<img src={require("../assests/download.png")} alt="download" loading="lazy"
					style={{ width: 15, height: 15 }} />}
					label={"XLSX"}
					onClick={exportToExcel}
				/>

				<CustomButton className={`ml-2 ${ShowFilterOut ? "bg-[#ff3b3b]" : ""}`}
					label={"Filter Out"}
					onClick={() => setShowFilterOut(val => !val)}
					disabled={!airportOptions?.length}
				/>

				{!loading && tableLoader && <Spin size="small" style={{ margin: 5, marginLeft: 20 }} />}
			</div>

			<Divider style={{ marginTop: 15, marginBottom: 15 }} />

			{loading && (
				// Show loading spinner while loading
				<div style={{ textAlign: 'center', padding: '70px' }}>
					<Spin size="large" />
				</div>
			)}

			{!loading && (
				<div id="MainView">
					{isDownloadPdf && <DisplayFilterData initialFilterOutValues={FilterOutFormik?.values} initialFilterValues={DashboardFilterFormik?.values} />}

					<div key={Dummy} style={{ position: "relative", display: "grid", gridTemplateColumns: ShowSecondGraph ? "repeat(2, 1fr)" : "repeat(1, 1fr)", gap: "16px", marginBottom: 15 }}>
						<MakeGraph data={FirstChartData} Title={FirstGraphTitle}
							sort={CurGraphCode.current ? !ShowSecondGraph : false} hideToggle={!CurGraphCode.current} isDownloadPdf={isDownloadPdf} isSecond={ShowSecondGraph} />

						{ShowSecondGraph && <MakeGraph data={SecondChartData} Title={SecondGraphTitle}
							sort={CurGraphCode.current} hideToggle={!CurGraphCode.current} isDownloadPdf={isDownloadPdf} isSecond={ShowSecondGraph} />}

						{!isDownloadPdf && <div style={{
							transition: "top 0.3s ease", position: "absolute",
							top: 8, right: 10, zIndex: 99
						}}>
							<CustomButton
								name={!ShowSecondGraph ? "Add Graph" : "Hide Graph"}
								label={ShowSecondGraph ? "✘" : "✚"}
								onClick={() => setShowSecondGraph(val => !val)}
							/>
						</div>}
					</div>

					<CustomTable
						rowKey={CurGraphType}
						data={TableData}
						columns={dynamicColumn(TableData)}
						bordered={false}
						loading={tableLoader ? !TableData?.length : false}
						scroll={{ x: true }}
						onRow={(row) => ({
							onClick: () => ShowSecondGraph ? formatGraphData(undefined, row, setSecondChartData) : formatGraphData(undefined, row, setFirstChartData),
						})}
						pagination={false}
					/>
				</div>
			)}
			{CurGraphCode.current && <Dydiff
				ref={DydiffRef}
				airportOptions={airportOptions}
				airlineOptions={airlineOptions}
				onRecordsUpdated={() => DashboardFilterFormik.handleSubmit()}
			/>}
			
			{/* Render CustomTable when loading is false */}
			<MismatchGuideAccordion marginTop={25} marginBottom={0}>
				<div>Red 'DY PAX' or 'AIRLINE SUM': DY count does not match the airline total.</div>
				<div>Red 'ENTRY VIA APP', 'ENTRY KIOSK', or 'DY DIFF': 'DY PAX' does not match 'ENTRY(APP) + ENTRY(OTDY/KIOSKS)'.</div>
				{/* <div>Click a red cell to jump to the DY DIFF editor below and correct the row.</div> */}
				<div>Click a red cell to jump to the DY DIFF section.</div>
			</MismatchGuideAccordion>

			<div style={{ textAlign: "center", marginTop: "30px", marginBottom: "20px" }}>
				Updated: {LastUpdatedTime}
			</div>
		</CustomCard>
	)
}

export default MainDashboard;
